export const graphQlUrl = process.env.VUE_APP_GRAPHQL_URL;
export const graphQlWs = process.env.VUE_APP_GRAPHQL_WS;
export const fileROot = process.env.VUE_APP_FILES_ROOT;
export const facebookAppId = process.env.VUE_APP_FACEBOOK_APPID;
export const apolloEngineService = process.env.VUE_APP_APOLLO_ENGINE_SERVICE;
export const apolloEngineKey = process.env.VUE_APP_APOLLO_ENGINE_KEY;
export const apolloEngineApiEndpoint = process.env.APOLLO_ENGINE_API_ENDPOINT;
export const fileServerUrl = process.env.VUE_APP_FILE_SERVER;
